import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import PrintIcon from "@mui/icons-material/Print";
import TableChart from "@mui/icons-material/TableChart";
import { Button, Stack } from "@mui/material";

const btnSx = { textTransform: "none", fontWeight: 600 };

/**
 * PDF / Excel / Print actions for legacy report pages (matches Change Of Attributes toolbar pattern).
 */
export default function ReportExportButtons({
  isEmpty,
  onEmpty,
  onPdf,
  onExcel,
  onPrint,
  sx,
}) {
  const guard = (fn) => () => {
    if (isEmpty) {
      onEmpty?.();
      return;
    }
    fn?.();
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      className="rpt-export-buttons"
      sx={{ ml: "auto", alignItems: "center", ...sx }}
    >
      <Button
        variant="outlined"
        color="error"
        size="small"
        disabled={isEmpty}
        startIcon={<PictureAsPdf fontSize="small" />}
        onClick={guard(onPdf)}
        sx={btnSx}
      >
        PDF
      </Button>
      <Button
        variant="outlined"
        color="success"
        size="small"
        disabled={isEmpty}
        startIcon={<TableChart fontSize="small" />}
        onClick={guard(onExcel)}
        sx={btnSx}
      >
        Excel
      </Button>
      <Button
        variant="outlined"
        color="inherit"
        size="small"
        disabled={isEmpty}
        startIcon={<PrintIcon fontSize="small" />}
        onClick={guard(onPrint)}
        sx={btnSx}
      >
        Print
      </Button>
    </Stack>
  );
}
